import { Intent, ProgressBar } from '@blueprintjs/core';

import { type RequestError } from '../../shared';

type SubscriptionUsageMeterProps = {
  ratio: number;
  isLoading?: boolean;
  error?: RequestError;
};

export const SubscriptionUsageMeter = ({ ratio, isLoading, error }: SubscriptionUsageMeterProps) => {
  // Show error state first (highest priority)
  if (error) {
    return <ProgressBar animate={false} stripes={false} value={0} intent={Intent.DANGER} />;
  }

  // Show loading state
  if (isLoading) {
    return <ProgressBar animate stripes value={undefined} intent={Intent.PRIMARY} />;
  }

  let intent: Intent;

  if (ratio >= 0.75 && ratio < 1) {
    intent = Intent.WARNING;
  } else if (ratio !== Infinity && ratio >= 1) {
    intent = Intent.DANGER;
  } else {
    intent = Intent.SUCCESS;
  }
  return <ProgressBar animate={false} stripes={false} value={ratio === Infinity ? 0 : ratio} intent={intent} />;
};
